module.exports = __webpack_public_path__ + "static/media/saying goodbye3.75eb89b3.jpg";